import { HistoryIcon, Plus } from "lucide-react";

/** Header buttons: new chat + conversation history toggle. */
export function ConversationActions({
  onToggleHistory,
  onNew,
  hideHistory = false,
}: {
  onToggleHistory: () => void;
  onNew: () => void;
  hideHistory?: boolean;
}) {
  return (
    <div className="flex items-center gap-0.5">
      <button
        onClick={onNew}
        title="New chat"
        className="rounded-md p-1.5 text-neutral-500 transition-colors hover:bg-neutral-800 hover:text-neutral-200"
      >
        <Plus className="h-4 w-4" />
      </button>
      {!hideHistory && (
        <button
          onClick={onToggleHistory}
          title="View conversations"
          className="rounded-md p-1.5 text-neutral-500 transition-colors hover:bg-neutral-800 hover:text-neutral-200"
        >
          <HistoryIcon className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
